(function () {
  "use strict";

  function isAllowedCheckoutUrl(value, shopDomain, storefrontHostname) {
    try {
      var url = new URL(value);
      if (url.protocol !== "https:") return false;
      return (
        url.hostname === shopDomain || url.hostname === storefrontHostname ||
        url.hostname.endsWith(".myshopify.com") ||
        url.hostname === "checkout.shopify.com" ||
        url.hostname.endsWith(".shopify.com")
      );
    } catch (_error) {
      return false;
    }
  }

  function shouldAutoOpen(root) {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("openBuilder") !== "1") return false;
      var requestedCustomizer = params.get("customizer");
      return !requestedCustomizer || requestedCustomizer === root.dataset.customizerId;
    } catch (_error) {
      return false;
    }
  }

  function init(root) {
    if (root.dataset.piupReady === "true") return;
    root.dataset.piupReady = "true";

    var openButton = root.querySelector("[data-piup-open]");
    var modal = root.querySelector("[data-piup-modal]");
    var closeButton = root.querySelector("[data-piup-close]");
    var frame = root.querySelector("[data-piup-frame]");
    var message = root.querySelector("[data-piup-message]");
    if (!openButton || !modal || !closeButton || !frame) return;

    var appOrigin = root.dataset.appOrigin;
    var shopDomain = root.dataset.shopDomain;
    var lastFocused = null;

    function builderUrl() {
      var url = new URL(root.dataset.builderRoute, appOrigin);
      var values = {
        source: "shopify",
        checkout: "shopify",
        builderType: "partner",
        storeId: root.dataset.partnerStoreId,
        shopifyStoreId: root.dataset.shopifyStoreId,
        shopDomain: shopDomain,
        shop: shopDomain,
        product: root.dataset.customizerId,
        customerId: root.dataset.customerId,
        customerEmail: root.dataset.customerEmail
      };
      Object.keys(values).forEach(function (key) {
        if (values[key]) url.searchParams.set(key, values[key]);
      });
      return url.toString();
    }

    function showMessage(text) {
      if (!message) return;
      message.textContent = text;
      message.hidden = !text;
    }

    function openBuilder() {
      lastFocused = document.activeElement;
      showMessage("");
      frame.src = builderUrl();
      modal.hidden = false;
      document.body.classList.add("piup-customizer-open");
      closeButton.focus();
    }

    function closeBuilder() {
      modal.hidden = true;
      frame.removeAttribute("src");
      document.body.classList.remove("piup-customizer-open");
      if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
    }

    openButton.addEventListener("click", openBuilder);
    closeButton.addEventListener("click", closeBuilder);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) closeBuilder();
    });

    window.addEventListener("message", function (event) {
      if (event.origin !== new URL(appOrigin).origin) return;
      if (event.source !== frame.contentWindow) return;
      var data = event.data;
      if (!data || typeof data !== "object") return;

      if (data.type === "close-builder") {
        closeBuilder();
        return;
      }

      if (data.type === "shopify-checkout-error") {
        showMessage(data.message || "We couldn't open secure checkout. Please try again.");
        return;
      }

      if (
        data.type === "redirect-to-checkout" &&
        isAllowedCheckoutUrl(data.checkoutUrl, shopDomain, window.location.hostname)
      ) {
        window.location.assign(data.checkoutUrl);
      }
    });

    if (shouldAutoOpen(root)) {
      window.setTimeout(openBuilder, 0);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-piup-customizer]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
